<template>
  <v-container class="overview-page">
    <v-row class="ma-0">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>description</v-icon>
          {{ $t('book/admin:documentation-rule.overview.docu-rules') }}
        </h2>

        <DataTable
            :headers="headers"
            :data="content"
            icon="edit"
            @clickedButton1="$router.push(`/${$store.state.manager.bookModuleUrl}/admin/documentation-rule/edit/${$event.id}`)"
            addBtn
            :addBtnRoute="`/${$store.state.manager.bookModuleUrl}/admin/documentation-rule/edit`"
            :addBtnText="$t('book/admin:documentation-rule.overview.add')"
            sortBy="translatedName"
            enabledSearch
            @cacheCommit="$store.commit('book/admin/storeDocumentationRuleOverviewSearch', $event)"
            :cachedSearch="$store.state.book.admin.documentationRuleOverviewSearch"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import DocumentationRuleService from "@/modules/book/services/documentation-rule-service";

import DataUtils from "@/modules/core/services/data-utils";
import Utils from "@/modules/core/services/utils";

import DocumentationRule from "@/modules/book/data/documentation-rule";

import DataTable from "@/modules/core/components/DataTable/DataTable";

export default {
  name: "DocumentationRuleOverview",
  components: {
    DataTable
  },
  data() {
    return {
      content: []
    }
  },
  computed: {
    headers() {
      return [
        {text: 'ID', value: 'id'},
        {text: this.$t('book/admin:documentation-rule.common.docu-type'), value: 'translatedName'},
        {text: this.$t('book/admin:documentation-rule.common.priority'), value: 'priority'},
        {text: '', value: 'controls', sortable: false}
      ]
    }
  },
  created() {
    DocumentationRuleService.readAllFromAPI(
      (res) => {
        this.content = DataUtils.parseDataToObjectArray(res.data, DocumentationRule);

        for (let j = 0; j < this.content.length; j++) {
          this.content[j].translatedName = this.$t('enums:facility-documentation-types.' + this.content[j].name);
        }
      },
      (error) => {
        Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/admin:documentation-rule.overview.docu-rules')}))
        this.$logger.error(error);
      }
    )
  }
}
</script>